<script lang="ts">
import "@cisco-u/icons/icons/cu-icon-check.js";
import "@cisco-u/icons/icons/cu-icon-close-x-filled.js";
import "@cisco-u/icons/icons/cu-icon-warning.js";
import "@cisco-u/alert/cu-alert.js";

import { defineComponent } from "vue";

import { EventBus } from "@/store/eventBus";

export default defineComponent({
  data() {
    return {
      bannerText: "",
      showMessage: false,
      bannerType: "success",
      bannerTitle: "",
      bannerAction: null as any,
    };
  },
  mounted() {
    EventBus.on("showBanner", (bannerData: any) => {
      this.bannerText = bannerData.message;
      this.bannerType = bannerData.type.toLowerCase();
      this.bannerTitle = bannerData.title;
      this.bannerAction = bannerData.action;
      this.showMessage = true;
      setTimeout(() => {
        this.showMessage = false;
      }, 3000);
    });
    this.$nextTick(() => {
      const alertEl = this.$el as HTMLElement;
      const shadow = alertEl?.shadowRoot;
      if (shadow) {
        let sheet = new CSSStyleSheet();
        sheet.insertRule(".alert { align-items: center; }");
        shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];
      }
    });
  },
  methods: {
    handleAlertClose(event: CustomEvent) {
      event.preventDefault();
      this.showMessage = false;
    },
  },
});
</script>

<template>
  <cu-alert
    class="message fixed z-[9999] mt-36 w-full"
    :type="
      bannerType == 'CML_SUCCESS' ? 'success' : bannerType == 'CML_ERROR' ? 'error' : bannerType
    "
    @cu-alert-close="handleAlertClose"
    :class="{ show: showMessage }"
    data-cy="message-banner"
  >
    <span slot="title">{{ bannerTitle }}</span>
    <span slot="message">{{ bannerText }}</span>
    <cu-link v-if="bannerAction" :href="bannerAction.url" slot="action">{{
      bannerAction.text
    }}</cu-link>
  </cu-alert>
</template>

<style scoped>
.message {
  visibility: hidden;
  opacity: 0;
  transition:
    opacity 450ms ease-in,
    visibility 450ms ease-in 0ms;
}

.message.show {
  visibility: visible;
  opacity: 1;
  transition:
    opacity 250ms ease-in,
    visibility 250ms ease-in 0ms;
}
</style>
